import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//import dayGridPlugin from '@fullcalendar/daygrid';
///import timeGridPlugin from '@fullcalendar/timegrid';
//import timeLinePlugin from '@fullcalendar/timeline';
//import interactionPlugin from '@fullcalendar/interaction';
//import { FullCalendarComponent } from '@fullcalendar/angular';
//import { OptionsInput } from '@fullcalendar/core';
import { RendezVous } from 'model/rendezvous';
import { AdminService } from '../../../services/admin';
import { Popup } from 'ng2-opd-popup';
import Swal from 'sweetalert2'
import { Employer } from 'model/model.employer';
import dayGridPlugin from '@fullcalendar/daygrid';


declare var toastr: any;
declare var mdtoast: any;
declare var $;
var success_message = mdtoast("Opération effectué avec succès. En attente de validation par le Médecin", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });

@Component({
  selector: 'app-calendrier-medecin',
  templateUrl: './calendrier-medecin.component.html',
  styleUrls: ['./calendrier-medecin.component.scss']
})
export class CalendrierMedecinComponent implements OnInit {
  id: any;
  //@ViewChild('fullcalendar') fullcalendar: FullCalendarComponent;
  //@ViewChild('fullcalendar', { static: false }) fullcalendar: FullCalendarComponent;

  rendezVous: RendezVous = new RendezVous();
  SUCCESS_MESSAGE: string = "Opération effectué avec succès. En attente de validation par le Médecin";
  ERROR_ENREGISTREMENT: string = "Opération non effectué";
  ERROR_MESSAGE: string = "Veuillez sélectionner votre ECOLE";
  ERROR_MESSAGE_DEJA_EXIST: string = "Code existe déjà";
  personel_id:number;


 // calendarPlugins = [dayGridPlugin];


  //liste de redv dr

  pageConsulter: any;
  motCle: String = "";
  currentPage: number = 0;
  size: number = 10;
  pages: Array<number>;


  

 // calendarPlugins = [dayGridPlugin, timeGridPlugin, timeLinePlugin, interactionPlugin];
 calendarPlugins = [dayGridPlugin]; // important

 /* public header = {
    left: 'prev, next, today',
    center: 'title',
    right: 'dayGridMonth,timeGridWeek,timeGridDay'
  };
  public locale = 'fr';
  public buttonText = {
    today: 'Aujourd\'hui',
    month: 'Mois',
    week: 'Semaine',
    day: 'Jour'
  };
  public allDayText = 'Toute la journée';
  options: OptionsInput;
  eventsModel: any;*/
  listerdv_by_dr: any;
  id_dr_actuel:number;
  nom_dr:string =" RASOLONDRAIBE Ifanomezana";
  lieu_dr:string ="Tsiazotafo";  

  @ViewChild('popup5') popup5: Popup;

  employer : Employer=new Employer(null);
  listeatt_by_dr: any;
  listerdv_by_agent: any;
  constructor(public activatedRoute: ActivatedRoute, private router: Router, public adminService: AdminService) {
    this.id = activatedRoute.snapshot.params['id'];
    this.id_dr_actuel = activatedRoute.snapshot.params['id2'];
    this.personel_id = this.adminService.getUserIdIscrit();
    console.log("this.personel_id" + this.personel_id);   
  }

  ngOnInit() {
   
    this.GetListeRDVParDR();
    this.listAgenda();
   // raha tsy mety de commantena ireto
    this.getInfoMedecinbyMatricule();
  }

 getInfoMedecinbyMatricule_default(){
    this.adminService.getInfoMedByIM(this.id)
    .subscribe(data => {
      this.nom_dr = data.nom;
      this.lieu_dr = data.lieu;
    }, err => {
      console.log(err);
    })
  }

  getInfoMedecinbyMatricule(){
    // this.employer.personnel_id = 92
  	// this.adminService.getStatistiqueConsultationParMedecin(this.employer).subscribe(data=>{
    //   this.employer=data;
    //   this.nom_dr =  this.employer.personnel_nom;
    //   this.lieu_dr = this.adminService.getLibelleLocalite(this.employer.localite_id);
  	// },err=>{

    // });

    this.adminService.getListeAttenteParMedParIM(this.id)
    .subscribe(data => {
      this.listeatt_by_dr=data;
      console.log("listeatt_by_dr"+ this.listeatt_by_dr);

      this.nom_dr =  data.nom;
      this.lieu_dr = this.adminService.getLibelleLocalite(data.localite_id);
    }, err => {
      console.log(err);
    })



    


  }










  GetListeRDVParDR() {
    this.adminService.getListeRDVParDr(this.id_dr_actuel)
      .subscribe(data => {
        this.listerdv_by_dr = data;
      }, err => {
        console.log(err);
      })
      this.GetListeRDVOnLineParAgent();
  }

  saveRDVOnLine(rdvdate,rdvheure,rdvmotif){
    this.rendezVous.id_agent= this.personel_id;
    this.rendezVous.id_employer=this.id_dr_actuel; 
    console.log("this.personel_id" + this.personel_id);
    console.log("this.id_dr_actuel" + this.id_dr_actuel);
    this.rendezVous.str_rendez_vous_date =rdvdate
    this.rendezVous.rendez_vous_heure=rdvheure
    this.rendezVous.rendez_vous_motif=rdvmotif
    console.log("rendezVOus str datxxxe" + rdvdate + "rendezVOus4444 str date" +  rdvheure + "rendezVOus4444ddd str date" + rdvmotif);
    Swal.fire({
      title: 'Êtes-vous sûr?',
      icon: 'info',
      text: 'Une fois que vous cliquer sur Oui, vous ne pouvez plus revenir en arrière. S\'il vous plaît soyez certain.',
      // icone: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, Valider RDV!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn
      
        this.adminService.saveRendezVous(this.rendezVous).subscribe(data=>{
          if(data.err){
            ;
           }   
             //toastr.error(data.err);return;
             this.popup5.hide();
             success_message.show()
           },err=>{   
           })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      //cancel btn
      }
    });
  }

  
 /// http://10.2.250.161:7001/cms/ws/rendez_ligne_agent?id=TSZ getListeRDVParAgent

  GetListeRDVOnLineParAgent() {
    this.adminService.getListeRDVParAgent(this.personel_id)
      .subscribe(data => {
        this.listerdv_by_agent = data;
      }, err => {
        console.log(err);
      })
  }
  

  saveRDVOnLine_tsetok(rdvdate,rdvheure,rdvmotif){
   //this.rendezVous.id_consultation= 1;
    this.rendezVous.id_agent= 300;
    this.rendezVous.id_employer=this.id_dr_actuel; 
    this.rendezVous.str_rendez_vous_date =rdvdate
    this.rendezVous.rendez_vous_heure=rdvheure
    this.rendezVous.rendez_vous_motif=rdvmotif
    console.log("rendezVOus str date" +this.rendezVous.str_rendez_vous_date+"   heure= "+this.rendezVous.rendez_vous_heure+" rendez vous date " +this.rendezVous.rendez_vous_date);
    // L : on line
    // V: valider par med
     
    //SWEET Alert

   
    this.adminService.saveRendezVous(this.rendezVous).subscribe(data=>{
   if(data.err){
     ;
    }   
      //toastr.error(data.err);return;
      this.popup5.hide();
    },err=>{   
    })
      }


    



  open() {
    this.popup5.options = { 
   
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
    color: "#0F7B79 ",
      showButtons: true,
      animationDuration: 1.5,
      header: "Créer rendez-vous en ligne",
      widthProsentage: 38,
      animation: "fadeInRight",
      confirmBtnContent: "Ajouter",
      cancleBtnContent: "Fermer",
    }

    this.popup5.show(this.popup5.options);
  }




  //aganda en ligne
  listAgenda() {
    this.adminService.getAgendaByEmployer(this.personel_id, this.motCle, this.currentPage, this.size)
      .subscribe(data => { //recois le dommer
        this.pageConsulter = data;
        this.pages = new Array(data.totalPages);
        console.log(data);
      }, err => {
        console.log(err);
      })
  }


  onClicRDVPatientConsulter(id : number) {
  
  }


  validerRDVPatientConsulter(){
  //mamadika ny etat , de lasa miaffiche any amin'ny Accueil (lasa valider statut rdv en ligne)
  
  }

  rejetRDVPatientConsulter(){
    //mamadika ny etat (lasa nom valider statut rdv en ligne)   
    }


  
  doSearch(){
    this.listAgenda();
}

}
